export var StatusChangeCause;
(function (StatusChangeCause) {
    StatusChangeCause[StatusChangeCause["TICKETS_MERGE"] = 10] = "TICKETS_MERGE";
    StatusChangeCause[StatusChangeCause["SNOOZE_EXPIRED"] = 20] = "SNOOZE_EXPIRED";
})(StatusChangeCause || (StatusChangeCause = {}));
;
//# sourceMappingURL=status-change-cause.enum.js.map